import React from "react";
import NavigationBar from "../../General/NavigationBar/NavigationBar";
import CRMSidebar from "../CRMSidebar/CRMSidebar";

const CRMLayout = ({ children }: { children: React.ReactNode }) => (
  <NavigationBar sidebar={<CRMSidebar />}>{children}</NavigationBar>
);

export default CRMLayout;
